import {
  Button,
  Flex,
  Heading,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { useCareGroupsPutMutation } from "./api/useCareGroupsMutation";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useCareGroupQuery } from "./api/useCareGroupsQuery";

export default function CareGroupsEditPage() {
  const navigate = useNavigate();
  const params = useParams();
  const { control, handleSubmit, reset } = useForm();
  const { mutate: careGroupsPutMutation } = useCareGroupsPutMutation();
  const { data } = useCareGroupQuery(params.id);

  const onSubmit = ({ groupName, groupDescription }) => {
    careGroupsPutMutation({ id: params.id, groupName, groupDescription });
    reset();
    navigate("/user/hr/care-groups");
  };

  if (data) {
    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex
          direction="column"
          minWidth={650}
          padding="32px 32px 32px 32px"
          backgroundColor="rgba(250,250,250,1)"
        >
          <Heading level="1" children="Edit Care Group"></Heading>
          <Flex direction="column" alignItems="flex-start">
            <Controller
              name="groupName"
              defaultValue={data?.groupName}
              control={control}
              render={({ field }) => (
                <TextField
                  isRequired={true}
                  minWidth="300px"
                  label="*Care Group Name"
                  {...field}
                />
              )}
            />
            <Controller
              name="groupDescription"
              defaultValue={data?.groupDescription}
              control={control}
              render={({ field }) => (
                <TextAreaField
                  minWidth="300px"
                  label="Care Group Description"
                  {...field}
                />
              )}
            />
          </Flex>
          <Flex gap="18px" direction="column" alignItems="flex-start">
            <Button variation="primary" children="Save" type="submit" />
          </Flex>
        </Flex>
      </form>
    );
  }
}
